import { logoutAction } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import Links from './Links';

class Nav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.watchWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.watchWidth);
  }

  watchWidth = () => {
    if (window.innerWidth > 991) {
      this.setState({ open: false });
    }
  };

  toggleNav = () => {
    this.setState({ open: !this.state.open });
  };

  logout = async (e) => {
    e.preventDefault();

    const { dispatch } = this.props;
    const token = localStorage.getItem('authToken');
    try {
      const variables = {
        token,
      };
    } catch (error) {
      console.log('logout error', error);
    }
    localStorage.removeItem('authToken');
    localStorage.removeItem('desiredRoute');

    dispatch(logoutAction());
    dispatch(push('/login'));
  };

  render() {
    const { isAuthenticated, tenant } = this.props;
    const { open } = this.state;
    const authenticatedBaseUrl = isAuthenticated ? '/dashboard' : '/';
    // destructure tenant

    // inject html to header and body
    const { headerHtml, bodyHtml } = tenant;
    const convertnode = (node) =>
      document.createRange().createContextualFragment(node);
    document.head.appendChild(convertnode(headerHtml));
    document.body.prepend(convertnode(bodyHtml));

    return (
      <div
        data-collapse='medium'
        className={`navbar w-nav ${isAuthenticated ? '' : 'anon-navbar'}`}
      >
        <div className='w-container'>
          <Link
            className={
              tenant.logoUrl
                ? 'tenant-logo offerboard-logo'
                : 'tenant-logo-hide'
            }
            style={{
              backgroundImage: `url(${tenant.logoUrl})`,
            }}
            to={{ pathname: authenticatedBaseUrl }}
          />
          {isAuthenticated && (
            <Fragment>
              {!open && <Links open={open} logout={this.logout} />}
              <button
                onClick={this.toggleNav}
                className={`w-nav-button ${open ? 'w--open' : ''}`}
              >
                <div className='w-icon-nav-menu' />
              </button>
            </Fragment>
          )}
        </div>
        {isAuthenticated ? (
          <div
            className='w-nav-overlay'
            style={
              open ? { height: 682, display: 'block' } : { display: 'none' }
            }
          >
            {open && <Links open={open} logout={this.logout} />}
          </div>
        ) : (window.location.href.indexOf('/republic/') > -1 ||
            window.location.href.indexOf('/wefunder/') > -1 ||
            window.location.href.indexOf('/realex/')) > -1 ? (
          ''
        ) : (
          <div className='navbar-login'>
            <a href='/login' className='small button'>
              Login
            </a>
            <a href='/register' className='small button'>
              Register
            </a>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ session, tenant }) => ({
  isAuthenticated: session.isAuthenticated,
  tenant,
});

Nav.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  tenant: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(withApollo(Nav));



// WEBPACK FOOTER //
// ./src/Layouts/Nav/index.js